import makeStyles from '@mui/styles/makeStyles';
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {color, font, type} from "common/tokens";

// A long reply is folded to a few lines with Read more, so one person's essay
// does not push the rest of the group off the card.
const CLAMP = 220;

const useStyles = makeStyles({
  text: {
    ...type.body,
    fontSize: 16,
    fontWeight: font.MEDIUM,
    color: color.TEXT,
    margin: 0,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  toggle: {
    ...type.body,
    fontSize: 16,
    fontWeight: font.MEDIUM,
    color: color.INFO,
    appearance: 'none',
    background: 'none',
    border: 'none',
    padding: 0,
    marginLeft: 6,
    cursor: 'pointer',
  },
});

const AnswerText = ({children = ''}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const value = String(children);
  const isLong = value.length > CLAMP;
  const shown = !isLong || expanded ? value : `${value.slice(0, CLAMP).trimEnd()}…`;

  return (
    <p className={classes.text}>
      {shown}
      {isLong && (
        <button type={'button'} className={classes.toggle} onClick={() => setExpanded(!expanded)}>
          {expanded ? t('readLess') : t('readMore')}
        </button>
      )}
    </p>
  );
};

export default AnswerText;
